/* @flow */
import * as favouriteActions from './actions';
import * as categoriesActions from '../../categories/actions';
import {Map, List, fromJS} from 'immutable';
import {Record} from '../../transit';

const State = Record({
    selected: null,
    favouriteItems: Map(),
    offerId: null
}, 'favourite');

const SELECTED = 'selected';
const FAVOURITE_ITEMS = 'favouriteItems';
const OFFER_ID = 'offerId';

const favouriteReducer = (state = new State(), action) => {

    switch (action.type) {

        case categoriesActions.FETCH_INIT_APP_SUCCESS: {
            const {categories, allOfferIds} = action.payload.data;
            const ids = fromJS(allOfferIds);
            let newState = state;
            state.get(FAVOURITE_ITEMS).forEach((obj, key) => {
                if (ids.findIndex(val => val === key) === -1) {
                    newState = newState.update(FAVOURITE_ITEMS, map => map.delete(key));
                }
            });
            return manageRemovedItems(newState, fromJS(categories));
        }

        case categoriesActions.FETCH_ONLY_CATEGORIES_SUCCESS: {
            const {categories} = action.payload.data;
            return manageRemovedItems(state, List(fromJS(categories)));
        }

        case favouriteActions.FAVOURITE_SET_OFFER_ID: {
            const {offerId} = action.payload;
            return state.set(OFFER_ID, parseInt(offerId));
        }

        case favouriteActions.FAVOURITE_ADD: {
            const {id} = action.payload;
            return addItemToOffer(state, parseInt(id));
        }

        case favouriteActions.FAVOURITE_REMOVE: {
            if (state.get(SELECTED) === null || !isOfferExists(state)) {
                return state;
            }
            let newState = state.updateIn([FAVOURITE_ITEMS, state.get(OFFER_ID)], map => map.delete(state.get(SELECTED)));
            if (newState.getIn([FAVOURITE_ITEMS], newState.get(OFFER_ID)).size === 0) {
                newState = newState.update(FAVOURITE_ITEMS, map => map.delete(newState.get(OFFER_ID)));
            }
            return selectItemByIndex(newState, null);
        }

        case favouriteActions.FAVOURITE_MOVE: {
            const {moveOf} = action.payload;

            const wantMoveIndex = state.get(SELECTED) + moveOf;
            const selected = state.get(SELECTED);
            const size = state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID)]).size;

            if (size > 1 && wantMoveIndex >= 0 && wantMoveIndex < size ) {
                const movedId = state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID), selected]);
                let newState = state
                    .updateIn([FAVOURITE_ITEMS, state.get(OFFER_ID)], list =>
                        list.set(selected, state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID), wantMoveIndex])))
                    .updateIn([FAVOURITE_ITEMS, state.get(OFFER_ID)], list =>
                        list.set(wantMoveIndex, movedId));
                return selectItemByIndex(newState, wantMoveIndex);
            }
            return state;
        }

        case favouriteActions.FAVOURITE_SELECT: {
            const {index} = action.payload;
            return selectItemByIndex(state, index);
        }

    }

    return state;
};

export default favouriteReducer;

function manageRemovedItems(state, categories) {
    let newState = state;
    state.get(FAVOURITE_ITEMS).forEach((obj, key) => {
        const items = categories.filter(c => c.get('offerId') === key).flatMap(cat => cat.get('items'));
        obj.forEach((fId, fIndex) => {
            const index = items.findIndex(item => item.get('id') === fId);
            if (index === -1) {
                newState = newState.updateIn([FAVOURITE_ITEMS, key], list => list.delete(fIndex));
            } else if (!items.getIn([index, 'active'])) {
                newState = newState.updateIn([FAVOURITE_ITEMS, key], list => list.delete(fIndex));
            }
        });

    });

    return newState;
}

function selectItem(state, id) {
    return selectItemByIndex(state, state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID)]).findIndex(val => val === id));
}

function selectItemByIndex(state, index) {
    if (index === null) {
        return state.set(SELECTED, null);
    }
    const size = state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID)]).size;
    if (size > 0) {
        if (index < 0) {
            return state.set(SELECTED, 0);
        } else if (index > (size - 1)) {
            return state.set(SELECTED, size - 1);
        }
        return state.set(SELECTED, index);
    }
    return state;
}

function addItemToOffer(state, itemId) {
    let newState = state;
    if (!isOfferExists(newState)) {
        newState = addOffer(newState);
    }
    if (isItemInOffer(newState, itemId)) {
        return selectItem(newState, itemId);
    }
    if (newState.getIn([FAVOURITE_ITEMS, newState.get(OFFER_ID)]).size >= 10 && newState.get(SELECTED) === null) {
        return newState;
    }
    if (newState.get(SELECTED) === null) {
        newState = newState.updateIn([FAVOURITE_ITEMS, newState.get(OFFER_ID)], list => list.push(itemId));
    } else {
        newState = newState.updateIn([FAVOURITE_ITEMS, newState.get(OFFER_ID)], list => list.set(newState.get(SELECTED), itemId));
    }
    return selectItemByIndex(newState, null);
}

function isItemInOffer(state, itemId): boolean {
    return state.getIn([FAVOURITE_ITEMS, state.get(OFFER_ID)]).findIndex(val => val === itemId) > -1;
}

function addOffer(state) {
    return state.update(FAVOURITE_ITEMS, map => map.set(state.get(OFFER_ID), List()));
}

function isOfferExists(state): boolean {
    return state.get(FAVOURITE_ITEMS).has(state.get(OFFER_ID));
}



// WEBPACK FOOTER //
// ./src/common/menu/favourite/reducer.js